export default __webpack_public_path__ + "static/media/Relógio 4.2d57bf05.svg";